
import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase'
import db from '@/main'

Vue.use(Vuex)

export default new Vuex.Store({

  state: {
    //<!-- user: {
    //  authenticated: false,
    //  id: null,
    //  Full_Name: null
    //    }, -->
    user: null,
    status: null,
    error: null

  },
  mutations: {

    setUser (state, payload) {
      state.user = payload
      // state.user.id = payload.id
      // state.user.BusinessUnit = payload.BusinessUnit
      // state.user.FullName = payload.FirstName+' '+payload.Surname
    },

    removeUser (state) {
      state.user = null
    },

    setStatus (state, payload) {
      state.status = payload
    },

    setError (state, payload) {
      state.error = payload
    },
    //SET_USER (state, user) {
      //state.authUser = user

    //},
   //authUser(state, user) {
      //state.user.id = user.uid
      //state.user.Full_Name = user.Full_Name
      //state.user.authenticated = true
     // console.log(state.user.Full_Name)
    //}, -->

  },
  actions: {
    createUserDoc({ commit },payload) {
      commit('setStatus', 'loading')
      const userdoc = {
        Title: payload.Title,
        Name: payload.Name,
        Surname: payload.Surname,
        BusinessUnit: payload.BusinessUnit,
        EmployeeCode: payload.EmployeeCode,
        Position: payload.Position,
        Gender: payload.Gender
      }
      console.log('userdoc')
      console.log(userdoc)
      db.collection('users').add(userdoc).then({

      })
    },

    createSystemActivity({ commit },payload) {
      commit('setStatus', 'loading')
      const systemactivity = {
        creatorid: payload.user.id,
        creatorname: payload.user.Full_Name,
        post: `<a href="/User/`+payload.user.id+`">`+payload.user.Full_Name+`</a> `+payload.contentvar+`<a href="`+payload.location+payload.docid+`">`+payload.docname+`</a>`,
        type: payload.type,
        createdon: new Date()
      }
      if(payload.user.profilephoto){        
        systemactivity.creatorimg = payload.user.profilephoto
      }
      db.collection('systemactivities').add(systemactivity).then({

      })
    },

    signUpAction ({ commit }, payload) {
      commit('setStatus', 'loading')
      firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
        .then((response) => {
          alert('success')
          // response will have user
          // user will have uid will be updated to the state
          db.collection('users').doc(response.user.uid).onSnapshot(snapshot => {
            var userdetails = snapshot.data()
            commit('setUser', response.user.uid)
          })
          // commit('setUser', response.user.uid)
          commit('setStatus', 'success')
          commit('setError', null)
          console.log('userdetails')
          console.log(payload)
          db.collection('users').doc(response.user.uid).set({
            title: payload.Title,
            name: payload.Name,
            surname: payload.Surname,
            gender: payload.Gender
          })
          const systemactivity = {
            creatorid: response.user.uid,
            creatorname: payload.Surname+' '+payload.Surname,
            post: `<a href="/User/`+response.user.uid+`">`+payload.Surname+' '+payload.Surname+`</a> joined Tribunes SA`,
            type: `New User`,
            createdon: new Date()
          }
          if(payload.profilephoto){        
            systemactivity.creatorimg = payload.user.profilephoto
          }
          db.collection('systemactivities').add(systemactivity).then({
    
          })
        })

        .catch((error) => {
          commit('setStatus', 'failure')
          commit('setError', error.message)
          alert(error.message)
        })
    },

    signUpbyAdminImportAction ({ commit }, payload) {
      return new Promise((resolve, reject) => {
       
        var config = {
  apiKey: "AIzaSyDtEVGDPadT-2LXaOTTwpr9tzCjbc6X4Qo",
  authDomain: "tribunes-sa.firebaseapp.com",
  databaseURL: "https://tribunes-sa.firebaseio.com",
  projectId: "tribunes-sa",
  storageBucket: "tribunes-sa.appspot.com",
  messagingSenderId: "1076497216756",
  appId: "1:1076497216756:web:0a915321edd08f08715aa1",
  measurementId: "G-JP5FGHMB9C"
};
        // const secondaryApp = firebase.initializeApp(config, "Secondary");
        if (firebase.apps.length === 1) {
          let secondaryApp = firebase.initializeApp(config, "Secondary")
          secondaryApp.auth().createUserWithEmailAndPassword(payload.Email,  payload.password)
        .then((response) => {
          const userdocid = response.user.uid
          // alert('success')
          const systemactivity = {
            creatorid: userdocid,
            creatorname: payload.Full_Name,
            post: `<a href="/User/`+userdocid+`">`+payload.Full_Name+`</a> joined Tribunes SA`,
            type: `New User`,
            createdon: new Date()
          }
          console.log(systemactivity)
          if(payload.profilephoto){        
            systemactivity.creatorimg = payload.profilephoto
          }
          console.log('logging more from store before create')
          console.log(response)
          resolve(response);
          db.collection('users').doc(userdocid).set({
            Name: payload.Name,
            Surname: payload.Surname,
            Full_Name: payload.Full_Name,
            Gender: payload.Gender,
            Title: payload.Title,
            Email: payload.Email,
            SubordinateArrayDBrules:{[userdocid]: true},
            Subordinatearrayquery: [userdocid]
          })
          console.log('here is userdocid',userdocid)
          
          db.collection('systemactivities').add(systemactivity).then({
            
          })
            
        }).catch((error) => {
       
          alert(error.message)
          reject(error);
        })
        }
        else{
          let secondaryApp = firebase.apps[1]
          secondaryApp.auth().createUserWithEmailAndPassword(payload.Email, payload.password)
        .then((response) => {
          // alert('success')
          const userdocid = response.user.uid
          const systemactivity = {
            creatorid: userdocid,
            creatorname: payload.Full_Name,
            post: `<a href="/User/`+userdocid+`">`+payload.Full_Name+`</a> joined Tribunes SA`,
            type: `New User`,
            createdon: new Date()
          }
          console.log(systemactivity)
          if(payload.profilephoto){        
            systemactivity.creatorimg = payload.profilephoto
          }
          console.log('logging more from store before create')
          console.log(response)
          resolve(response);
          db.collection('users').doc(userdocid).set({
            Name: payload.Name,
            Surname: payload.Surname,
            Full_Name: payload.Full_Name,
            Gender: payload.Gender,
            Title: payload.Title,
            Email: payload.Email,
            SubordinateArrayDBrules:{[userdocid]: true},
            Subordinatearrayquery: [userdocid]
          })
          
            
        }).catch((error) => {
       
          alert(error.message)
          reject(error);
        })
        }
        
      
      })
    },

    signUpbyAdminAction ({ commit }, payload) {
      commit('setStatus', 'loading')
      firebase.auth().createUserWithEmailAndPassword(payload.Email, payload.password)
        .then((response) => {
          alert('success')
          const userdocid = response.user.uid
          db.collection('users').doc(response.user.uid).set({
            Name: payload.Name,
            Surname: payload.Surname,
            Full_Name: payload.Full_Name,
            Gender: payload.Gender,
            Title: payload.Title,
            Email: payload.Email,
            SubordinateArrayDBrules:{[userdocid]: true},
            Subordinatearrayquery: [userdocid]
          })
          const systemactivity = {
            creatorid: response.user.uid,
            creatorname: payload.Full_Name,
            post: `<a href="/User/`+response.user.uid+`">`+payload.Full_Name+`</a> joined Tribunes SA`,
            type: `New User`,
            createdon: new Date()
          }
          if(payload.profilephoto){        
            systemactivity.creatorimg = payload.user.profilephoto
          }
          db.collection('systemactivities').add(systemactivity).then({
    
          })
        })

        .catch((error) => {
          commit('setStatus', 'failure')
          commit('setError', error.message)
          alert(error.message)
        })
    },

    signInAction ({ commit }, payload) {
      firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
        .then((response) => {
          commit('setUser', response.user.uid)
          commit('setStatus', 'success')
          commit('setError', null)
        })
        .catch((error) => {
          commit('setStatus', 'failure')
          commit('setError', error.message)
          alert(error.message)
        })
    },


    signOutAction ({ commit }) {
      firebase.auth().signOut()
        .then((response) => {
          commit('setUser', null)
          commit('setStatus', 'success')
          commit('setError', null)
        })
        .catch((error) => {
          commit('setStatus', 'failure')
          commit('setError', error.message)
          alert(error.message)
        })
    }
  },

  getters: {

    status (state) {
      return state.status
    },

    user (state) {
      return state.user
    },

    error (state) {
      return state.error
    }
  }
})

  